<template>
  <router-view />
</template>

<script>
export default {
  name: "member-management",
};
</script>
